// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web — features/operacional/consultas.ts
//
//  Filtros das consultas operacionais enviados ao SERVIDOR (PKG-08):
//  busca, status, período, cliente, vendedor, ordenação. Antes as telas
//  filtravam só a página carregada (USA-OPA-04..13).
// ════════════════════════════════════════════════════════════════════════════

import type { DirecaoOrdenacao } from '@/lib/consultas';

/** Filtros comuns (vazio/undefined = sem filtro). Datas "yyyy-MM-dd". */
export interface FiltroConsultaOperacional {
  busca?: string;
  status?: string;
  dtInicio?: string;
  dtFim?: string;
  clienteId?: number;
  vendedorId?: number;
  ordenarPor?: string;
  direcao?: DirecaoOrdenacao;
  /** Filtros específicos de cada tela (motorista, rotaId…). */
  [extra: string]: string | number | boolean | undefined;
}

/** Remove vazios/zeros para não poluir a query string. */
export function paramsConsulta(f: FiltroConsultaOperacional = {}): Record<string, string | number | boolean> {
  const out: Record<string, string | number | boolean> = {};
  for (const [k, v] of Object.entries(f)) {
    if (v === undefined || v === '' || v === 0 || v === 'todos' || v === 'todas') continue;
    out[k] = v;
  }
  return out;
}

/** KPIs de DAV/OS (GET /api/dav/resumo, /api/os/resumo) — consulta inteira, sem o status. */
export interface DavKpi {
  total: number;
  abertos: number;
  valorAbertos: number;
  baixados: number;
  entregues: number;
  valorTotal: number;
}

/** Linha de listagem com o nome do vendedor (as listagens de DAV/OS/Orçamento/Condicional o trazem). */
export type ComVendedor<T> = T & { vendedorNome?: string | null };

/** Linha da consulta de OS: + status cadastrado (último acompanhamento) com a cor do cadastro. */
export type OsResumoLista<T> = ComVendedor<T> & {
  statusAtual?: string | null;
  statusCor?: string | null;
  /** 0 = Alta, 1 = Normal. */
  prioridade?: number;
  dtAgendamento?: string | null;
};
